import { c as _c } from "react/compiler-runtime";
import { Stack, Typography } from '@mui/material';
import type { MPARequest } from '@repo/api-gw-sdk';
import { CopyToClipboardButton } from '@/components/buttons/copyToClipboardButton';
import { MainDialog } from '@/components/dialogs/mainDialog';
import { JsonViewerPanel } from '@/components/shared/jsonViewer';
import { parseJson } from '@/utils/string';
const parseBody = (request: MPARequest): object | null => request.requestBody ? parseJson<object>(request.requestBody) ?? null : null;
export const MpaRequestDetails = t0 => {
  const $ = _c(17);
  const {
    request
  } = t0;
  let t1;
  if ($[0] !== request) {
    t1 = parseBody(request);
    $[0] = request;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const body = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      fontFamily: "monospace"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      fontFamily: "monospace"
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== request.requestMethod) {
    t4 = <Typography variant="h4" sx={t3}>{request.requestMethod}</Typography>;
    $[4] = request.requestMethod;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      fontFamily: "monospace",
      wordBreak: "break-all"
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== request.requestPath) {
    t6 = <Typography variant="body1" sx={t5}>{request.requestPath}</Typography>;
    $[7] = request.requestPath;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t4 || $[10] !== t6) {
    t7 = <Stack direction="row" alignItems="baseline" gap="8px" sx={t2}>{t4}{t6}</Stack>;
    $[9] = t4;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== body) {
    t8 = body ? <JsonViewerPanel data={body} /> : <Typography variant="body1" color="text.secondary">Request body is empty</Typography>;
    $[12] = body;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t7 || $[15] !== t8) {
    t9 = <Stack gap="16px">{t7}{t8}</Stack>;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
};
export const MpaRequestDetailsDialog = t0 => {
  const $ = _c(25);
  const {
    isOpen,
    onClose,
    request
  } = t0;
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== isOpen || $[1] !== onClose || $[2] !== request) {
    const body = parseBody(request);
    T0 = MainDialog;
    t3 = isOpen;
    t4 = false;
    if ($[9] !== onClose) {
      t5 = {
        title: "Request details",
        onClose
      };
      t1 = {
        text: "Close",
        onClick: onClose,
        "data-testid": "close-mpa-request-json-viewer"
      };
      $[9] = onClose;
      $[10] = t1;
      $[11] = t5;
    } else {
      t1 = $[10];
      t5 = $[11];
    }
    t2 = body ? <CopyToClipboardButton textToCopy={JSON.stringify(body)} buttonLabel="Copy" /> : undefined;
    $[0] = isOpen;
    $[1] = onClose;
    $[2] = request;
    $[3] = T0;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    T0 = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
  }
  let t6;
  if ($[12] !== t1 || $[13] !== t2) {
    t6 = {
      primaryButton: t1,
      children: t2
    };
    $[12] = t1;
    $[13] = t2;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      minHeight: "350px",
      maxHeight: "80%",
      overflow: "auto"
    };
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== request) {
    t8 = <Stack className="px-[40px]" sx={t7}><MpaRequestDetails request={request} /></Stack>;
    $[16] = request;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== T0 || $[19] !== t3 || $[20] !== t4 || $[21] !== t5 || $[22] !== t6 || $[23] !== t8) {
    t9 = <T0 isOpen={t3} isLoading={t4} header={t5} footer={t6}>{t8}</T0>;
    $[18] = T0;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
};